import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Card, Typography, message, Divider, Empty, Input, Space, Select, Segmented } from "antd";
import { SearchOutlined, SkinOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { RenderImageCard } from "./components/renderImage";
import { AuthContext } from "../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

// OPTIONS SEXO
const options_sexo = [
  { label: "Todos", value: 0 },
  { label: "Masculino", value: 1 },
  { label: "Feminino", value: 2 },
];

// OPTIONS FILTRO
const options_filtro = [
  { label: "Meu usuário", value: 0 },
  { label: "Filial", value: 1 },
  { label: "Outro colaborador", value: 2 },
];

export const UniformesProdutos = () => {
  const navigate = useNavigate();
  const { session } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  // FILTRO
  const [filtroSexo, setFiltroSexo] = useState(0);
  const [search, setSearch] = useState("");

  // FILIAIS
  const [filiais, setFiliais] = useState([]);
  const [filialSelected, setFilialSelected] = useState(null);

  // COLABORADORES
  const [colaboradores, setColaboradores] = useState([]);
  const [colaboradorSelected, setColaboradorSelected] = useState(null);

  // TIPO
  const [filtroTipo, setFiltroTipo] = useState(0);

  useEffect(() => {
    if (session?.usuario?.sexo === "M") {
      setFiltroSexo(1);
    } else if (session?.usuario?.sexo === "F") {
      setFiltroSexo(2);
    } else {
      setFiltroSexo(0);
    }

    listarFiliais();
    listarColaboradores();
  }, []);

  useEffect(() => {
    listarProdutos(filtroTipo, colaboradorSelected, filialSelected);
  }, [filtroTipo, colaboradorSelected, filialSelected]);

  // LISTAR FILIAIS
  const listarFiliais = async () => {
    setLoading(true);
    const api = await http("get", `v1/uniformes_produtos/listar_filiais`, []);
    if (api.statusCode === 200) {
      let options_filiais = [];
      for (const f of api.response.data) {
        options_filiais.push({ value: f.id, label: f.descricao });
      }
      setFiliais(options_filiais);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR COLABORADORES
  const listarColaboradores = async () => {
    setLoading(true);
    const api = await http("get", `v1/uniformes_produtos/listar_colaboradores`, []);
    if (api.statusCode === 200) {
      let options_colaboradores = [];
      for (const f of api.response.data) {
        options_colaboradores.push({ value: f.id, label: f.nome });
      }
      setColaboradores(options_colaboradores);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarProdutos = async (tipo, colab, fil) => {
    const data = {
      id_colaborador: colab === null ? 0 : colab,
      id_filial: fil === null ? 0 : fil,
      tipo: tipo,
    };

    setLoading(true);
    const api = await http("post", `v1/uniformes_produtos/listar_produtos_pedido`, data);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // PESQUISAR
  const handleFilter = (pesquisar, marcado) => {
    let filteredData = dados?.filter(
      (val) =>
        val.descricao?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.valor?.toString()?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    switch (marcado) {
      case 1:
        filteredData = filteredData.filter((e) => {
          return e.sexo === "M";
        });
        break;
      case 2:
        filteredData = filteredData.filter((e) => {
          return e.sexo === "F";
        });
        break;
      default:
        break;
    }

    return filteredData;
  };

  // CLIQUE PRODUTO
  const handleProdutoSelect = (id_produto) => {
    switch (filtroTipo) {
      case 1:
        navigate(`/uniformes/produtos/pedido/${id_produto}/1/${filialSelected ? filialSelected : 0}`);
        break;
      case 2:
        navigate(`/uniformes/produtos/pedido/${id_produto}/2/${colaboradorSelected ? colaboradorSelected : 0}`);
        break;
      default:
        navigate(`/uniformes/produtos/pedido/${id_produto}/0/0`);
        break;
    }
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search, filtroSexo) : [];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Uniformes" onClickBack={() => navigate("/uniformes/pedidos")} />
            <HeaderTitle
              title="Uniformes Produtos"
              subtitle="Realizar novo pedido"
              icon={<SkinOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Space direction="vertical" size={0}>
                  <Text style={{ fontSize: 12 }} type="secondary">
                    Pesquisar:
                  </Text>
                  <Input
                    size="middle"
                    value={search}
                    maxLength={100}
                    prefix={<SearchOutlined />}
                    className="input"
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Pesquisar..."
                    allowClear
                  />
                </Space>

                <Space direction="vertical" size={0}>
                  <Text style={{ fontSize: 12 }} type="secondary">
                    Selecione o sexo:
                  </Text>
                  <Segmented value={filtroSexo} onChange={(e) => setFiltroSexo(e)} options={options_sexo} />
                </Space>
                <Space direction="vertical" size={0}>
                  <Text style={{ fontSize: 12 }} type="secondary">
                    Fazer pedido para:
                  </Text>
                  <Select
                    placeholder="Selecione uma opção"
                    disabled={loading}
                    style={{ width: "100%", minWidth: 180 }}
                    options={options_filtro}
                    value={filtroTipo}
                    onChange={(e) => setFiltroTipo(e)}
                  />
                </Space>

                {filtroTipo === 1 && (
                  <Space direction="vertical" size={0}>
                    <Text style={{ fontSize: 12 }} type="secondary">
                      Selecione a Filial:
                    </Text>
                    <Select
                      showSearch
                      placeholder="Selecione uma filial"
                      disabled={loading}
                      style={{ width: "100%", minWidth: 180 }}
                      options={filiais}
                      value={filialSelected}
                      onChange={(e) => setFilialSelected(e)}
                      filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Space>
                )}
                {filtroTipo === 2 && (
                  <Space direction="vertical" size={0}>
                    <Text style={{ fontSize: 12 }} type="secondary">
                      Selecione o Colaborador:
                    </Text>
                    <Select
                      showSearch
                      placeholder="Selecione o colaborador"
                      disabled={loading}
                      style={{ width: "100%", minWidth: 180 }}
                      options={colaboradores}
                      value={colaboradorSelected}
                      onChange={(e) => setColaboradorSelected(e)}
                      filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Space>
                )}
              </Space>
              <Divider />
              <Row>
                {dadosFilter.map((d) => {
                  return (
                    <RenderCard
                      key={d.id}
                      descricao={d.descricao}
                      valor={d.valor}
                      idImagem={d.id_img}
                      onClick={() => handleProdutoSelect(d.id)}
                    />
                  );
                })}
                {dados?.length === 0 && (
                  <div className="align-center">
                    <Empty />
                  </div>
                )}
              </Row>
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};

// RENDER CARD
const RenderCard = ({ idImagem, valor, descricao, onClick }) => {
  return (
    <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={6} align="left" style={{ padding: 10 }}>
      <Card
        hoverable
        style={{ width: "100%", maxWidth: "100%", flexGrow: 1 }}
        bodyStyle={{ padding: 0 }}
        onClick={onClick}>
        <RenderImageCard idImagem={idImagem} />
        <Divider style={{ margin: 0 }} />
        <Space direction="vertical" style={{ padding: 20 }}>
          <Text strong style={{ fontSize: 14 }}>
            {descricao}
          </Text>
          <Text type="secondary">R$ {valor}</Text>
        </Space>
      </Card>
    </Col>
  );
};
